<template>
  <div class="menu-wrap">
    <!-- 顶部按钮 -->
	<el-form-item label="平台" type="primary">
	  <el-select v-model="platform" @change="forPlatform">
	    <el-option label="中台" :value="中台"></el-option>
		<el-option label="学校" :value="学校"></el-option>
		<el-option label="教育局" :value="教育局"></el-option>
	  </el-select>
	</el-form-item>
    <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增菜单</el-button>

    <!-- 树形菜单（带操作） -->
    <el-tree
      ref="menuTree"
      class="mt-20"
      :data="treeData"
      :props="treeProps"
      node-key="id"
      default-expand-all
    >
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <span class="tree-label">{{ node.label }}</span>
        <span class="tree-btn">
          <el-button
            type="text"
            icon="el-icon-plus"
            size="mini"
			v-if="data.status!=10"
            @click.stop="openAddChildDialog(data)"
          >新增下级</el-button>
          <el-button
            type="text"
            icon="el-icon-edit"
            size="mini"
			v-if="data.status!=10"
            @click.stop="openEditDialog(data)"
          >编辑</el-button>
          <el-button 
		  v-if="data.status!=10"
            type="text"
            icon="el-icon-delete"
            size="mini"
            @click.stop="handleDelete(data)"
          >删除</el-button>
        </span>
      </div>
    </el-tree>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="菜单信息" :visible.sync="dialogVisible" width="500px" center>
      <el-form :model="form" label-width="100px">
        <el-form-item label="菜单名称">
          <el-input v-model="form.menuName" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单编码">
          <el-input v-model="form.menuCode" placeholder="请输入唯一编码"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单">
          <el-select v-model="form.parentId" :disabled="isParentDisabled">
            <el-option label="一级菜单" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属平台">
          <el-radio-group v-model="form.platform">
            <el-radio label="中台"></el-radio>
            <el-radio label="学校"></el-radio>
            <el-radio label="教育局"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否业务菜单">
          <el-switch v-model="form.isBusiness" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <!-- 层级字段（隐藏，仅后台用） -->
        <el-form-item label="层级" v-if="false">
          <el-input v-model="form.level"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenuTree, addMenu, updateMenu, delMenu } from './memu.js'
export default {
  name: 'MenuTable',
  data() {
    return {
      treeData: [],
      treeProps: {
        label: 'menuName',
        children: 'children'
      },
      dialogVisible: false,
      // 表单数据
      form: {
        id: null,
        menuName: '',
        menuCode: '',
        parentId: 0,
        platform: '中台',
        isBusiness: '0',
        level: 1
      },
      platform: '',
      // 是否禁用上级菜单选择（新增下级时禁用）
      isParentDisabled: false
    }
  },
  mounted() {
    this.loadTreeData()
  },
  methods: {
	  forPlatform(val){
		  this.platform=val
		  this.loadTreeData()
	  },
    // 加载菜单树
    async loadTreeData() {
      const res = await getMenuTree(this.platform)
      this.treeData = res.data.data
    },
    // 打开新增【一级菜单】弹窗
    openAddDialog() {
      this.isParentDisabled = false
      this.dialogVisible = true
      this.form = {
        id: null,
        menuName: '',
        menuCode: '',
        parentId: 0,
        platform: '中台',
        isBusiness: '0',
		status:1,
        level: 1 // 一级菜单默认 level=1
      }
    },
    // 打开新增【下级菜单】弹窗
    openAddChildDialog(parentMenu) {
      this.isParentDisabled = true // 禁用上级选择
      this.dialogVisible = true
      this.form = {
        id: null,
        menuName: '',
        menuCode: '',
        parentId: parentMenu.id, // 固定为当前菜单ID
        platform: parentMenu.platform, // 继承平台
        isBusiness: '0',
		status:1,
        level: (parentMenu.level || 1) + 1 // 层级+1
      }
    },
    // 打开编辑弹窗
    openEditDialog(row) {
      this.isParentDisabled = false // 编辑时可以改上级（如果需要也可以禁用）
      this.dialogVisible = true
      this.form = { ...row }
    },
    // 提交新增/编辑
    async submitForm() {
      try {
        if (this.form.id) {
          await updateMenu(this.form)
          this.$message.success('编辑成功')
        } else {
          await addMenu(this.form)
          this.$message.success('新增成功')
        }
        this.dialogVisible = false
        this.loadTreeData()
      } catch (err) {
        this.$message.error('操作失败')
      }
    },
    // 删除菜单
    handleDelete(row) {
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delMenu(row.id)
        this.$message.success('删除成功')
        this.loadTreeData()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mt-20 {
  margin-top: 20px;
}
.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.tree-label {
  flex: 1;
}
.tree-btn {
  margin-left: 10px;
}
</style>